import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import capitalize from 'lodash/capitalize';

import { StatusPillVariant, StyledStatusPill } from './StatusPill.styles';

interface Props {
  status: string;
  magentaBooked?: boolean;
}

const normalize = (status: string) => status?.toUpperCase().replaceAll(' ', '_');

const StatusPill: FC<Props> = ({ status, magentaBooked }) => {
  const { t } = useTranslation();
  const normalized = normalize(status);

  const label =
    normalized === 'NA'
      ? t('Not available')
      : normalized === 'CANCELLED'
        ? t('Canceled')
        : capitalize(status?.replaceAll('_', ' ').toLowerCase());

  return (
    <StyledStatusPill variant={normalized as StatusPillVariant} magentaBooked={magentaBooked}>
      <p>{label}</p>
    </StyledStatusPill>
  );
};

export default StatusPill;
